import React, { useEffect, useState } from "react";
import Slider from "react-slick";

const Banner = ({ desktopImages = [], mobileImages = [] }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth <= 991);
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const settings = {
    autoplay: true,
    autoplaySpeed: 2500,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    pauseOnHover: true,
  };

  const imagesToDisplay = isMobile ? mobileImages : desktopImages;
  const imageArray = Object.values(imagesToDisplay);
  const finalImages =
    imageArray.length > 0 ? imageArray : ["/assets/img/banner.png"];

  return (
    <section className="banner-section" data-sal="fade" data-sal-duration="1000">
      <Slider {...settings} className="banner-carousel">
        {finalImages.map((imgSrc, index) => {
          const imageUrl = imgSrc.startsWith("/storage")
            ? `${process.env.REACT_APP_WEB_URL}${imgSrc}`
            : "/assets/img/banner.png";

          return (
            <div key={index}>
              <img
                src={imageUrl}
                alt={`banner ${index + 1}`}
                loading={index === 0 ? "eager" : "lazy"}
                decoding="async"
                style={{ width: "100%", height: "auto" }}
              />
            </div>
          );
        })}
      </Slider>
    </section>
  );
};

export default Banner;
